import React from 'react'
import { Link } from 'gatsby'

const Footer = () => (
  <footer className="g-bg-gray-dark-v1 g-color-white-opacity-0_8 g-py-20">
    <div className="container">
      <div className="row">
        <div className="col-md-8 text-center text-md-left g-mb-10 g-mb-0--md">
          <div className="d-lg-flex">
            <small className="d-block g-font-size-default g-mr-10 g-mb-10 g-mb-0--md">2021 &copy; All Rights Reserved.</small>
            <ul className="u-list-inline">
              <li className="list-inline-item">
                <Link to="/privacy-policy" className="g-color-white-opacity-0_8 g-color-white--hover">Privacy Policy</Link>
              </li>
              <li className="list-inline-item">
                <span>|</span>
              </li>
              <li className="list-inline-item">
                <Link to="/terms-of-service" className="g-color-white-opacity-0_8 g-color-white--hover">Terms of Service</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-4 align-self-center">
          <ul className="list-inline text-center text-md-right mb-0">
            <li className="list-inline-item g-mx-10" data-toggle="tooltip" data-placement="top" title="Facebook">
              <a href="https://www.facebook.com/Hempgrid-110106873942054" className="g-color-white-opacity-0_5 g-color-white--hover">
                <i className="fa fa-facebook"></i>
              </a>
            </li>
            <li className="list-inline-item g-mx-10" data-toggle="tooltip" data-placement="top" title="Linkedin">
              <a href="https://linkedin.com/company/hempgrid" className="g-color-white-opacity-0_5 g-color-white--hover">
                <i className="fa fa-linkedin"></i>
              </a>
            </li>
            <li className="list-inline-item g-mx-10" data-toggle="tooltip" data-placement="top" title="Youtube">
              <a href="https://www.youtube.com/channel/UClWVKVNu7JJVPW4iaCpD7Nw" className="g-color-white-opacity-0_5 g-color-white--hover">
                <i className="fa fa-youtube"></i>
              </a>
            </li>
            <li className="list-inline-item g-mx-10" data-toggle="tooltip" data-placement="top" title="Twitter">
              <a href="https://twitter.com/hempgrid" className="g-color-white-opacity-0_5 g-color-white--hover">
                <i className="fa fa-twitter"></i>
              </a>
            </li>
            <li className="list-inline-item g-mx-10" data-toggle="tooltip" data-placement="top" title="Instagram">
              <a href="https://www.instagram.com/hempgrid/" className="g-color-white-opacity-0_5 g-color-white--hover">
                <i className="fa fa-instagram"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
